import React from "react";
import styled from 'styled-components';
import I10n from '../../../features/i10n';
import MsxIcons from '../../msx-icons';
import SharedMailComponent from "../../../components/mail";
import { appConfiguration } from "../../../utils/app-starter";
import { SECONDARY_COLOR } from "../../../color-constants";
import { raiseIACAnalyticsEvent } from "../../../utils/analytics-logger";
import { IAC_SEND_MAIL_EVENT_NAMES } from "../../../constants";

const ContentWrapperContainer = styled.div`
  border-radius: 10px;
  align-self: center;
  display: flex;
  flex-direction: column;
  margin: 2em;
  max-width: 1100px;
  width: 100%;
  background-color: white;
  overflow: hidden;
  @media (max-width: 800px) {
    max-width: 100%;
    margin: 2em 0;
  }
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  background-color: white;
  color: #333333;
  max-width: 100%;
  border-radius: 10px;

  @media all and (-ms-high-contrast: none) {
    margin: 0px;
    max-height: 100%;
  }

  se-tabbar .opt-content.tab-alternative nav {
    height: auto;
    a {
      flex: 1 1 0px;
    }

  }
`;

const Header = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  color: ${SECONDARY_COLOR};
  color: var(--se-primary, ${SECONDARY_COLOR});
  margin: 0px 20px;
  padding: 10px 0px;
`;

const Title = styled.span`
  font-weight: bold;
  font-size: 20px;
`;

const CloseIcon = styled.span`
  display: inline-block;
  color: #626469;
  cursor: pointer;
`;

const SharedMailComponentWrapper = styled.div`
  background-color: #F4F4F4;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
`;

const Body = styled.div`
display: flex;
flex-direction: column;
flex: 1 1 auto;
align-items: stretch;
`;

class ModalSendEmail extends React.PureComponent {

  componentDidMount() {
    raiseIACAnalyticsEvent(IAC_SEND_MAIL_EVENT_NAMES.OPEN_MAIL);
  }

  render = () => {
    return (
      <ContentWrapperContainer>
      <Container>
        <Header id="modalSendMail-header">
          <Title>{I10n.get('save_configuration.mail.message.title')}</Title>
          <CloseIcon onClick={(e) => {
              e.preventDefault();
              this.props.closeModal();
            }}>
              <MsxIcons name="close"></MsxIcons>
          </CloseIcon>
        </Header>
        <Body id="modalSendMail-Body">
          <SharedMailComponentWrapper id="modalSendMail-SharedMailContentWrapper">
            <SharedMailComponent
              primaryColor={appConfiguration.globalStyles.primaryColor}
              secondaryColor={appConfiguration.globalStyles.secondaryColor}
              sendTabLabel={I10n.get("save_configuration.mail.message.send_personal")}
              sendTitle={I10n.get('save_configuration.mail.message.send_personal.title')}
              sendNameLabel={I10n.get('save_configuration.name.label')}
              sendEmailLabel={I10n.get('save_configuration.email.label')}

              shareTabLabel={I10n.get("save_configuration.mail.message.send_other")}
              shareTitle={I10n.get('save_configuration.mail.message.send_others.title')}
              shareNameLabel={I10n.get('save_configuration.email.label')}
              shareEmailLabel={I10n.get('save_configuration.email.label')}
              shareRecipientNameLabel={I10n.get('save_configuration.recipient_name.label')}
              shareRecipientEmailLabel={I10n.get('save_configuration.recipient_email.label')}

              showSubscribe={false}
              shareMessageLabel={I10n.get('save_configuration.mail.message.label')}
              cancelLabel={I10n.get('app.action.cancel')}
              submitLabel={I10n.get('app.action.send')}
              onSubmit={this.props.onSubmit}
              onCancel={this.props.onCancel}
              senderName={this.props.senderName}
              senderEmail={this.props.senderEmail}
              recaptchaKey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
            ></SharedMailComponent>
          </SharedMailComponentWrapper>
        </Body>
      </Container>
      </ContentWrapperContainer>
    );
  }
}

export default ModalSendEmail;
